import { defineComponent as _defineComponent } from 'vue'
import ActivityPaymentsListBlock from '@/app/components/payments/ActivityPaymentsListBlock.vue';
import { useAuthStore } from '@/app/store/authModule';
import { AuthorityType } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityPaymentsView',
  setup(__props) {

const authStore = useAuthStore();
const canExport = authStore.hasAuthorities(AuthorityType.EXPORT_PAYMENTS);

return { __sfc: true,authStore, canExport, ActivityPaymentsListBlock }
}

})